import { Modal } from "bootstrap";

export function clearBootstrapModalResidue() {
  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
}

/**
 * Hide a Bootstrap modal by element id and resolve when fully hidden.
 */
export function hideBootstrapModalById(modalId) {
  const el = document.getElementById(modalId);
  if (!el) {
    return Promise.resolve();
  }

  const instance = Modal.getInstance(el) || Modal.getOrCreateInstance(el);
  if (!el.classList.contains("show")) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    el.addEventListener("hidden.bs.modal", () => resolve(), { once: true });
    instance.hide();
  });
}
